import { Course } from "../models";

export const displayOrderPredicate = (a: Course, b: Course) =>
  (a.displayOrder || 9999) - (b.displayOrder || 9999);

